import ajax from "./ajax";

export function getEmailMarketing(shopId) {
  return ajax(`/shops/${shopId}/marketing`, { server: "node" });
}

export function listMarketingAudiences(shopId, data) {
  return ajax(`/shops/${shopId}/marketing/audiences`, {
    method: "POST",
    data,
    server: "node",
  });
}

export function connectEmailMarketing(shopId, data) {
  return ajax(`/shops/${shopId}/marketing/connections`, {
    method: "POST",
    data,
    server: "node",
  });
}

export function disconnectEmailMarketing(shopId, connectionId) {
  return ajax(`/shops/${shopId}/marketing/connections/${connectionId}`, {
    method: "DELETE",
    server: "node",
  });
}

export function retryEmailMarketing(shopId, connectionId) {
  return ajax(`/shops/${shopId}/marketing/connections/${connectionId}/retry`, {
    method: "POST",
    server: "node",
  });
}

export function updateMarketingFlow(shopId, flowKey, data) {
  return ajax(`/shops/${shopId}/marketing/flows/${flowKey}`, {
    method: "PATCH",
    data,
    server: "node",
  });
}

export function getSellerEmailMarketing(enterpriseId) {
  return ajax(`/enterprises/${enterpriseId}/marketing/sellers`, { server: "node" });
}

export function previewSellerLists(enterpriseId, data) {
  return ajax(`/enterprises/${enterpriseId}/marketing/sellers/lists`, {
    method: "POST",
    data,
    server: "node",
  });
}

export function connectSellerEmailMarketing(enterpriseId, data) {
  return ajax(`/enterprises/${enterpriseId}/marketing/sellers`, {
    method: "POST",
    data,
    server: "node",
  });
}

export function updateSellerEmailMarketing(enterpriseId, connectionId, data) {
  return ajax(`/enterprises/${enterpriseId}/marketing/sellers/${connectionId}`, {
    method: "PATCH",
    data,
    server: "node",
  });
}

export function retrySellerEmailMarketing(enterpriseId, connectionId) {
  return ajax(
    `/enterprises/${enterpriseId}/marketing/sellers/${connectionId}/retry`,
    { method: "POST", server: "node" }
  );
}

export function disconnectSellerEmailMarketing(enterpriseId, connectionId) {
  return ajax(`/enterprises/${enterpriseId}/marketing/sellers/${connectionId}`, {
    method: "DELETE",
    server: "node",
  });
}

export function getSellerMarketingPrompt() {
  return ajax("/enterprises/marketing/seller-prompt", { server: "node" });
}

export function saveSellerMarketingConsent(data) {
  return ajax("/enterprises/marketing/seller-consent", {
    method: "POST",
    data,
    server: "node",
  });
}

export function dismissSellerMarketingPrompt(data) {
  return ajax("/enterprises/marketing/seller-prompt/dismiss", {
    method: "POST",
    data,
    server: "node",
  });
}

export function saveMarketingAddress(shopId, mailingAddress) {
  return ajax(`/shops/${shopId}/marketing/address`, {
    method: "PUT",
    data: { mailingAddress },
    server: "node",
  });
}
